import { render, staticRenderFns } from "./OrderAndBuy.vue?vue&type=template&id=6f096eea&scoped=true&"
import script from "./OrderAndBuy.vue?vue&type=script&lang=js&"
export * from "./OrderAndBuy.vue?vue&type=script&lang=js&"
import style0 from "./OrderAndBuy.vue?vue&type=style&index=0&id=6f096eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f096eea",
  null
  
)

export default component.exports